import { useCallback } from 'react';
import { Group } from '../store/ErisInformationStore';
import useErisApi from './axios/useErisApi';

function useGroupRepo() {
  const { get } = useErisApi();

  const searchGroupsRequest = useCallback(
    async (groupId?: string) =>
      await get<Group[]>('api/er/groups', {
        params: groupId != null ? { id: groupId } : undefined,
      }),
    [get]
  );

  return { searchGroupsRequest };
}

export default useGroupRepo;
